import React from 'react';
import { List, Datagrid, TextField, ShowButton } from 'react-admin';

import CardActions from '@material-ui/core/CardActions';
import { ListButton, DeleteButton, EditButton } from 'react-admin';
import DeleteIcon from '@material-ui/icons/Delete';

export const PagesList = (props) => (
    <List title="Content Analytics" actions={<PageActions />} {...props}>
        <Datagrid>
            <TextField source="title" />
            <TextField source="contentType" label="Type" />
            <TextField source="yvalue" label="Trailing visits" />
            <EditButton label="Personalize" />
        </Datagrid>
    </List>
);


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PageActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
    </CardActions>
);


// WEBPACK FOOTER //
// ./src/pages/lists/Pages.js